import { useState } from 'react';

export default function MaterialSection() {
  const [activeMaterial, setActiveMaterial] = useState<'exterior' | 'interior' | 'structure'>('exterior');

  const materials = {
    exterior: {
      title: '外装素材',
      subtitle: 'Premium Exterior',
      description: '高品質なPUレザーを使用。手触りが良く、傷や汚れに強い耐久性を実現。',
      features: ['耐久性に優れたPUレザー', '傷・汚れに強い表面加工', '手に馴染む質感'],
      image: 'https://public.readdy.ai/ai/img_res/2f62291650a20d70f87a058856d59aba.jpg',
    },
    interior: {
      title: '内装素材',
      subtitle: 'Soft Interior',
      description: 'スエード素材の内装が、iPadの画面とユーザーの心理を優しく保護します。',
      features: ['柔らかなスエード素材', '画面を傷から守る', 'ラグジュアリーなルックス'],
      image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/c5cfb8932d0bbd27af1bc31b64e5f692.jpeg',
    },
    structure: {
      title: '構造設計',
      subtitle: 'Origami Structure',
      description: '折り紙構造により、軽量性と強度を両立。9段階の角度調整を可能にします。もしかしたらもっとあるかも？',
      features: ['折り紙構造による軽量化', '高い強度と耐久性', '9段階の角度調整機構'],
      image: 'https://readdy.ai/api/search-image?query=minimalist%20origami%20folding%20structure%20diagram%20in%20clean%20white%20and%20gray%20tones%20technical%20illustration%20style%20simple%20background%20modern%20design%20showcase%20geometric%20precision&width=800&height=600&seq=material-structure-001&orientation=landscape',
    },
  };

  return (
    <section id="material" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* ヘッダー */}
        <div className="text-center mb-12">
          <span className="text-sm font-medium tracking-wider text-[#8B6BAE] uppercase mb-4 block">Material</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            素材への<span className="text-[#8B6BAE]">こだわり</span>
          </h2>
          <p className="text-lg text-[#6B6B6B] max-w-2xl mx-auto">
            厳選された素材と精密な構造設計が、長く使える品質を実現します。
          </p>
        </div>

        {/* タブ */}
        <div className="flex justify-center gap-3 mb-12">
          {(['exterior', 'interior', 'structure'] as const).map((material) => (
            <button
              key={material}
              onClick={() => setActiveMaterial(material)}
              className={`px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                activeMaterial === material
                  ? 'bg-[#8B6BAE] text-white'
                  : 'bg-[#FAFAFA] text-[#6B6B6B] border border-[#E5E5E5] hover:border-[#8B6BAE]'
              }`}
            >
              {materials[material].title}
            </button>
          ))}
        </div>

        {/* コンテンツエリア */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* 画像エリア */}
          <div className="bg-[#FAFAFA] rounded-2xl p-8 border border-[#E5E5E5]">
            <div className="w-full h-[500px] flex items-center justify-center bg-white rounded-xl overflow-hidden">
              <img
                src={materials[activeMaterial].image}
                alt={materials[activeMaterial].title}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* テキストエリア */}
          <div>
            <span className="text-sm font-medium tracking-wider text-[#8B6BAE] uppercase mb-3 block">
              {materials[activeMaterial].subtitle}
            </span>
            <h3 className="text-4xl font-bold text-[#2C2C2C] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              {materials[activeMaterial].title}
            </h3>
            <p className="text-lg text-[#6B6B6B] mb-8 leading-relaxed">
              {materials[activeMaterial].description}
            </p>
            <ul className="space-y-4">
              {materials[activeMaterial].features.map((feature, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center bg-[#8B6BAE] rounded-full flex-shrink-0">
                    <i className="ri-check-line text-sm text-white"></i>
                  </div>
                  <span className="text-base text-[#2C2C2C]">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
